import { MailSplitData } from "@dashboard-v3/api";
import { Grid, Typography } from "@material-ui/core";
import { PropertyLabel, StyledList } from "./styled";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  data: MailSplitData;
}

export default function MailSplitDetails(props: Props) {
  const { t } = useTranslation("tracing");
  const { data } = props;
  const { allRecipients } = data;

  return (
    <Grid item xs={12}>
      {!!allRecipients.length && (
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <PropertyLabel>{t("recipients")}:</PropertyLabel>
          <StyledList>
            {allRecipients.map(({ recipient, status }) => (
              <li key={recipient} style={{ paddingLeft: "4px", marginTop: 20 }}>
                {status ? (
                  <Trans
                    t={t}
                    i18nKey={`recipientStatus.${status}`}
                    values={{
                      recipient,
                      interpolation: { escapeValue: false },
                    }}
                  >
                    <Typography
                      variant="subtitle2"
                      color="textSecondary"
                      display="inline"
                    ></Typography>
                    <Typography variant="body2" display="inline"></Typography>
                  </Trans>
                ) : (
                  <Typography variant="subtitle2" color="textSecondary">
                    {recipient}
                  </Typography>
                )}
              </li>
            ))}
          </StyledList>
        </Grid>
      )}
    </Grid>
  );
}
